<div
  class="d-flex flex-column align-items-center h-100 w-100 justify-content-center px-4 py-4 modal-main"
>
  <div class="header mt-1 my-2 pb-4 w-100">
    <div class="d-flex justify-content-between">
      <img
        src="/assets/svg/ico-chevron-back-outline.svg"
        alt="back button"
        class="pointer-cursor"
        (click)="navigateBack()"
      />
      <h1 class="modal-title m-auto">{{ 'ADD_A_DEVICE' | translate }}</h1>
      <img
        src="/assets/svg/ico-hamburger-close.svg"
        class="cross-button pointer-cursor"
        (click)="closeDialog()"
      />
    </div>
  </div>

  <div class="mb-3">
    <p class="text-center heading-one">
      {{ 'ENTER_DEVICE_INFORMATION' | translate }}
    </p>
    <p class="paragraph-text text-center px-2 mx-4">
      {{ 'ENTER_THE_DEVICE_INFORMATION_LISTED' | translate }}
    </p>
  </div>

  <div
    class="d-flex flex-column justify-content-start w-100 px-3 form-container"
  >
    <form
      [formGroup]="deviceInformationForm"
      (keyup.enter)="submit()"
      #deviceInformation
      [attr.autofocus]="focusOnPreviousModal ? '' : null"
      tabindex="0"
    >
      <div class="rounded-top form-field">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>{{ 'MAC_ADDRESS_ADD_DEVICE' | translate }}</mat-label>
          <input
            matInput
            formControlName="serialNumber"
            placeholder="Ex. f1:a2:a3:a4:a5:b3"
          />
          <mat-error>
            <span *ngIf="formInstance?.serialNumber?.errors?.required">{{
              'YOU_MUST_ENTER_VALID_MAC_ADDRESS' | translate
            }}</span>

            <span *ngIf="formInstance?.serialNumber?.errors?.macAddress">{{
              'YOU_MUST_ENTER_VALID_MAC_ADDRESS' | translate
            }}</span>
          </mat-error>

          <mat-error *ngIf="formInstance?.serialNumber?.errors?.whitespace"
            >{{ 'EXTRA_WHITE_SPACES_ARE_NOT_SUPPORTED' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </form>
  </div>
  <div class="row w-100 px-3 py-3">
    <div class="w-100">
      <button
        class="btn btn-danger update-btn px-3"
        [disabled]="!deviceInformationForm.valid"
        (click)="submit()"
      >
        {{ 'CONTINUE' | translate }}
      </button>
    </div>
  </div>
</div>
